import { Message, Modal } from "view-design"
import $fn from "./fn"
//Ajax-JSON函数
//强制为同步模式
function AjaxJson(url, method, args, fn, dataType) {
    var obj = null;
    var ajax = new AjaxObject();
    ajax.URL = url;
    ajax.dataType = dataType;
    ajax.Method = method;
    ajax.Async = true;
    ajax.Args = args;
    ajax.onSuccess = function (xhr) {
        var text = xhr.responseText;
        if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
        eval("obj=" + text);
        fn(obj, xhr);
    };
    ajax.onFailure = function (xhr) {
        var text = xhr.responseText;
        if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
        eval("obj=" + text);
        fn(obj, xhr);
    };
    ajax.Connect();
    return obj;
}

//Ajax标准类模块
function AjaxObject() {
    this.URL = "";
    this.Method = "GET";
    this.Async = true;
    this.Args = null;
    this.onSuccess = function () { };
    this.onFailure = function () { };
    this.Request = window.XMLHttpRequest
        ? new XMLHttpRequest()
        : new ActiveXObject("Microsoft.XMLHTTP");
    this.Connect = function () {
        this.Method = this.Method.toUpperCase();
        if (this.Method == "GET" && this.Args) {
            this.Request.open(this.Method, this.URL, this.Async);
            if (this.dataType == "json") {
                this.Request.setRequestHeader(
                    "Content-type",
                    "application/json;charset=UTF-8"
                );
            } else {
                this.Request.setRequestHeader(
                    "Content-type",
                    "application/x-www-form-urlencoded;"
                );
            }
            var args = "";
            if (typeof this.Args == "object") {
                // 增加sign验签参数
                this.Args = $fn.toSign(this.Args)
                var arr = new Array();
                for (var k in this.Args) {
                    var v = this.Args[k];
                    arr.push(k + "=" + v);
                }
                args = arr.join("&");
                this.URL += (this.URL.indexOf("?") == -1 ? "?" : "&") + args;
                this.Args = null;
            }
        }
        var q = this.Request;
        var evt1 = this.onSuccess;
        var evt2 = this.onFailure;
        var evt3 = this.onLoadend;
        this.Request.onreadystatechange = function () {
            _onStateChange(q, evt1, evt2, evt3);
        };

        this.Request.open(this.Method, this.URL, this.Async);
        if (this.URL.indexOf("/box_serverlist") < 0 && this.URL.indexOf("down_url.json") < 0) {
            this.Request.setRequestHeader(
                "token",
                $fn.cookies.getToken("token")
            );
            this.Request.setRequestHeader(
                "device",
                "web"
            );
            this.Request.setRequestHeader(
                "appv",
                "1.0.0"
            );
        }
        if (this.Method == "POST" || this.Method == "PUT" || this.Method == "DELETE") {
            if (this.dataType == "json") {
                this.Request.setRequestHeader(
                    "Content-type",
                    "application/json;charset=UTF-8"
                );
            } else {
                this.Request.setRequestHeader(
                    "Content-type",
                    "application/x-www-form-urlencoded;"
                );
            }
            let args = "";
            if (typeof this.Args == "string") {
                args = this.Args;
            } else if (typeof this.Args == "object") {
                // 增加sign验签参数
                this.Args = $fn.toSign(this.Args)
                if (this.dataType == "json") {
                    this.Args = JSON.stringify(this.Args);
                } else {
                    let arr = new Array();
                    for (let k in this.Args) {
                        let v = this.Args[k];
                        arr.push(k + "=" + v);
                    }
                    args = arr.join("&");
                    this.Args = encodeURI(args);
                }
            }
        }
        try {
            this.Request.send(this.Args);
        } catch (e) {
            console.log("connect exception.");
        }
    };

    function _onStateChange(xhr, success, failure) {
        if (xhr.readyState == 4) {
            var s = xhr.status;
            if (s == 0) {
                console.log("connect to url failure.");
            } else if (s >= 200 && s < 400) {
                success(xhr);
            } else {
                failure(xhr);
            }
        }
    }
}

class http {
    constructor() { }

    originPost(obj, fn) {
        if (obj.json !== undefined) {
            AjaxJson(obj.url, "post", obj.json, fn, "json");
        } else {
            AjaxJson(obj.url, "post", obj.data, fn);
        }
    }
    originGet(obj, fn) {
        if (obj.json !== undefined) {
            AjaxJson(obj.url, "get", obj.json, fn, "json");
        } else {
            AjaxJson(obj.url, "get", obj.data, fn);
        }
    }
    originPut(obj, fn) {
        if (obj.json !== undefined) {
            AjaxJson(obj.url, "put", obj.json, fn, "json");
        } else {
            AjaxJson(obj.url, "put", obj.data, fn);
        }
    }
    originDelete(obj, fn) {
        if (obj.json !== undefined) {
            AjaxJson(obj.url, "delete", obj.json, fn, "json");
        } else {
            AjaxJson(obj.url, "delete", obj.data, fn);
        }
    }
    httpPost(obj) {
        return new Promise(resolve => {
            this.originPost(obj, res => {
                resolve(res);
            });
        });
    }
    httpGet(obj) {
        return new Promise(resolve => {
            this.originGet(obj, res => {
                resolve(res);
            });
        });
    }
    httpPut(obj) {
        return new Promise(resolve => {
            this.originPut(obj, res => {
                resolve(res);
            });
        });
    }
    httpDelete(obj) {
        return new Promise(resolve => {
            this.originDelete(obj, res => {
                resolve(res);
            });
        });
    }
    // axiosGet(obj) {
    //     return new Promise(resolve => {
    //         originAxiosGet(obj, res => {
    //             resolve(res);
    //         });
    //     });
    // }
}

export default new http();
